import { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@reducers/index';
import LoaderComponent from '@components/atom/layout/loader';
import SelectBox from '@components/template/ranking/categoryranking/selectBox';
import GridChartBox from '@components/template/ranking/categoryranking/gridChartBox';

const AppInfo = lazy(() => import('@components/template/layout/appInfo/appInfo'));

// TODO: selectBox 에서 userId, date 두가지 항목이 데이터를 요청하는 params 이다
// datepicker 에서 date 변경시 데이터 요청 처리!
const Category = () => {
  return (
    <>
      <div className="app-info">
        <Suspense fallback={<LoaderComponent />}>
          <AppInfo />
        </Suspense>
      </div>
      <SelectBox />
      <GridChartBox />
    </>
  );
};

export default Category;
